module.exports = __webpack_public_path__ + "static/media/icon_search.8e535b22.svg";